import React, { useState, useRef } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import PropTypes from 'prop-types';
import { Grid, Button, Menu, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CSVLink } from 'react-csv';

const ReportFileExports = ({ elementId, reportTitle, downloadFileName, data, downloadFileOption, headers, filtersData }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const csvLink = useRef();
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const downloadPdfDocument = () => {
        const input = document.getElementById(elementId);
        html2canvas(input).then((canvas) => {
            const imgData = canvas.toDataURL('image/png', 1.0);
            const imgWidth = 190;
            const pageHeight = 290;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            const pdf = new jsPDF('pt', 'mm');
            let position = 0;
            pdf.text(reportTitle, 70, 20);
            pdf.addImage(imgData, 'PNG', 20, 30, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 20, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }
            if (filtersData.length > 0) {
                const filterTextY = imgHeight + 40;
                pdf.setFontSize(8);
                pdf.text('Filters:', 50, filterTextY);
                let lineHeight = 5;
                for (let i = 0; i < filtersData.length; i++) {
                    pdf.text(filtersData[i].label, 70, filterTextY + lineHeight);
                    pdf.text(filtersData[i].value, 100, filterTextY + lineHeight);
                    lineHeight += 5;
                }
            }
            pdf.save(`${downloadFileName}.pdf`);
        });
        handleClose();
    };

    const downloadCSVDocument = () => {
        csvLink.current.link.click();
        handleClose();
    };

    return (
        <Grid sx={{ float: 'right' }}>
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
            >
                Export
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button'
                }}
            >
                {downloadFileOption === 'all' && (
                    <>
                        <MenuItem onClick={downloadPdfDocument}>Download PDF</MenuItem>
                        <MenuItem onClick={downloadCSVDocument}>Download CSV</MenuItem>
                    </>
                )}
                {downloadFileOption === 'csv' && <MenuItem onClick={downloadCSVDocument}>Download CSV</MenuItem>}
                {downloadFileOption === 'pdf' && <MenuItem onClick={downloadPdfDocument}>Download PDF</MenuItem>}
            </Menu>
            <CSVLink data={data} headers={headers} filename={`${downloadFileName}.csv`} className="hidden" ref={csvLink} target="_blank" />
        </Grid>
    );
};

ReportFileExports.propTypes = {
    elementId: PropTypes.string,
    reportTitle: PropTypes.string,
    downloadFileName: PropTypes.string,
    downloadFileOption: PropTypes.string,
    data: PropTypes.array,
    headers: PropTypes.array,
    filtersData: PropTypes.array
};

export default ReportFileExports;
